import classNames from 'classnames';
import { observer } from 'mobx-react';
import { memo, useMemo } from 'react';
import AddItemChoiceButton from '../../components/AddItemChoiceButton/AddItemChoiceButton';
import MealChoice from '../../components/MealChoice/MealChoice';
import mealsStore from '../../store/mealsStore';
import integrationsStore from 'src/mobx/integrationStore';
import { IMealChoice, IMealGroup } from 'src/types/combo';
import IntegrationManager from 'src/view/components/IntegrationManager/IntegrationManager';
import './style.scss';

interface IProps {
  group: IMealGroup;
}

const MealChoices: React.FC<IProps> = memo(
  observer((props: IProps): JSX.Element => {
    const choices = useMemo((): IMealChoice[] => {
      return mealsStore.meal?.choices.filter((_choice) => _choice.group_id === props.group.id) || [];
    }, [mealsStore.meal?.choices, props.group.id]);

    return (
      <div className={classNames('meal-choices', { 'mt-2': choices.length })}>
        {choices.length ? choices.map((choice) => <MealChoice key={choice.id} choice={choice} />) : null}

        <IntegrationManager
          setting={integrationsStore.posRestrictions?.comboMealItemChoiceCreate}
          wrapperClassName="mt-4"
          tooltipOptions={{ wrapperClassName: 'meal-choices__btn-add-wrapper' }}
          withTooltip
        >
          <AddItemChoiceButton group_id={props.group.id} />
        </IntegrationManager>
      </div>
    );
  })
);

export default MealChoices;
